import { useMutation, useQueryClient } from "@tanstack/react-query";
import { acceptQuoteById } from "../actions/acceptQuoteById.actions";

export const useQuoteAcceptMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ quoteId, data }: any) => acceptQuoteById(quoteId, data),

    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["quotes"] });
      window.dispatchEvent(
        new CustomEvent("flownect:quotes-updated", { detail: { quoteId: variables.quoteId } }),
      );
    },

    onError: (error) => {
      console.error("Failed to accept quote:", error);
    },
  });
};
